export { default as ImageWithTextSideBySide } from './ImageWithTextSideBySide';
